import styled, { css, keyframes } from 'styled-components';
var getSlideDownAnimation = function getSlideDownAnimation(translateYPos) {
  return keyframes(["from{transform:translateY(", "px);}to{transform:translateY(0);}"], translateYPos);
};
var getSlideUpAnimation = function getSlideUpAnimation(translateYPos) {
  return keyframes(["from{transform:translateY(0);}to{transform:translateY(", "px);}"], translateYPos);
};
export var SlideAnimation = styled.div.withConfig({
  displayName: "animation__SlideAnimation",
  componentId: "sc-11uy939-0"
})(["", ""], function (_ref) {
  var transitionState = _ref.transitionState,
    translateYPos = _ref.translateYPos,
    animationDuration = _ref.animationDuration;
  var slideDownAnimation = getSlideDownAnimation(translateYPos);
  var slideUpAnimation = getSlideUpAnimation(translateYPos);
  switch (transitionState) {
    case 'entering':
      return css(["animation:", " ease-out ", "ms;"], slideDownAnimation, animationDuration);
    case 'entered':
      return css(["transform:translateY(0);"]);
    case 'exiting':
      return css(["animation:", " ease-in ", "ms;"], slideUpAnimation, animationDuration);
    case 'exited':
      return css(["transform:translateY(", "px);"], translateYPos);
  }
});